import { createSlice } from "@reduxjs/toolkit";
import {  stateEnum } from "../constants/enum";
const { beamCard } = stateEnum

let initialState = {
    detailParams: [],
    isNewEntry: false
}



const beamCardSlice = createSlice({
    name: beamCard,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;

        },
        resetDetailParams: (state) => {
            state.detailParams = []
            state.isNewEntry = true

        },
        setDetailParams: (state,action) => {
            state.detailParams = action.payload
        },
        
    },
   
})
export const { setNewEntryMode, resetDetailParams,setDetailParams } = beamCardSlice.actions
export default beamCardSlice.reducer